export default __webpack_public_path__ + "static/media/bhcosmetics.ff1b9ed1.png";